import * as React from "react";
import { History } from "history";
import { connect } from "react-redux";
import {  animateScroll as scroll, scroller } from "react-scroll";
import { delayFunction } from "../../core/utils/object";
import { AppLocation, IApplicationState } from "../../typings";

export interface LinkProps {
    to?: string[];
    child: any;
    key: string;
    isNode?: boolean;
    className?: string;
}
interface IProps {
    vertical?: boolean;
    links: LinkProps[];
    history: History;
    type?: "fill";
    className?: string;
    idk?: string;
    backColor?: string;
    end?: boolean;
}

interface IState {
    hidden: boolean;
    lastScrollTop: number;
}

export class NavView extends React.Component<
    IProps & {
        appLocation: AppLocation;
    },
    IState
> {
    constructor(props) {
        super(props);

        this.state = {
            hidden: false,
            lastScrollTop: 0,
        };
    }

    public componentDidMount() {
        //if(!this.props.vertical)
        //  window.addEventListener('scroll', this.handleScroll);
    }

    public scrollTop = () => {
        scroll.scrollToTop();
    };

    scrollTo = (id: string) => {
        scroller.scrollTo(id, {
            duration: 800,
            delay: 0,
            smooth: "easeInOutQuart",
        });
    };

    public componentWillUnmount() {
        //if(!this.props.vertical)
        //    window.removeEventListener('scroll', this.handleScroll)
    }

    getDocHeight() {
        return Math.max(
            document.body.scrollHeight,
            document.documentElement.scrollHeight,
            document.body.offsetHeight,
            document.documentElement.offsetHeight,
            document.body.clientHeight,
            document.documentElement.clientHeight,
        );
    }

    hasScrolled = () => {
        const st = window.scrollY;

        // Make sure they scroll more than delta
        if (Math.abs(this.state.lastScrollTop - st) <= 50) return;

        // If they scrolled down and are past the navbar, add class .nav-up.
        // This is necessary so you never see what is "behind" the navbar.
        if (st > this.state.lastScrollTop && st > 70) {
            // Scroll Down
            this.setState({ hidden: true });
        } else {
            // Scroll Up
            // if(st + window.outerHeight < this.getDocHeight()) {
            //   this.showHeader();
            // }
            if (st < this.getDocHeight()) {
                this.setState({ hidden: false });
            }
        }

        this.setState({
            lastScrollTop: st,
        });
    };

    handleScroll = (e) => {
        this.hasScrolled();
    };

    getActiveClass = (location: string) => {
        console.log(this.props.appLocation);
        if (this.props.appLocation == location) return "active";
        return "";
    };

    container: any;

    render() {
        const { hidden } = this.state;

        return (
            <div
                ref={(e) => (this.container = e)}
                style={{ backgroundColor: this.props.backColor }}
                className={`nav not-mobile ${this.props.vertical ? "vertical vertical-left" : "horizontal"} ${
                    this.props.end ? "end" : ""
                } ${hidden ? "up" : ""} ${this.props.type} ${this.props.className}`}
            >
                {this.props.links.map((item, index) => {
                    if (item.isNode) return item.child;

                    return (
                        <a
                            key={item.key + index}
                            className={
                                "nav-item " + this.getActiveClass(item.key) + " " + (this.props.type || "nofill") + " " + item.className
                            }
                            onClick={() => {
                                if (!!item.to) if (this.props.history.location.pathname != item.to[0]) this.props.history.push(item.to[0]);

                                delayFunction(() => {
                                    if (!!item.to && item.to.length > 0) this.scrollTo(item.to[1]);
                                }, 100);
                            }}
                        >
                            <div key={item.key}>{item.child}</div>
                        </a>
                    );
                })}
            </div>
        );
    }
}

function mapToProps(state: IApplicationState, ownProps: IProps) {
    return {
        ...ownProps,
        appLocation: state.appLocation,
        idk: state.containerOnScreen.idk,
    };
}

export default connect(mapToProps)(NavView);



// WEBPACK FOOTER //
// ./src/components/navigation/nav.tsx